//         ,''',
//        .' ., .',                                  ../'''',
//        .'. %%, %.',                            .,/' .,%   :
//       .'.% %%%,`%%%'.    .....,,,,,,.....   .,%%% .,%%'. .'
//       : %%% %%%%%%',:%%>>%>' .,>>%>>%>%>>%%>,.   `%%%',% :                         ||```````````````````````````||
//       : %%%%%%%'.,>>>%'   .,%>%>%'.,>%>%' . `%>>>,. `%%%:'                         ||                           ||
//       ` %%%%'.,>>%'  .,%>>%>%' .,%>%>%' .>>%,. `%%>>,. `%                          ||      ΠΡΟΣΟΧΗ: ΝΕΥΡΙΑΖΕΙ   ||
//        `%'.,>>>%'.,%%%%%%%' .,%%>%%>%' >>%%>%>>%.`%% %% `,                         ||     ΑΝ ΑΚΟΥΜΠΗΣΕΤΕ ΤΟΝ    ||
//        ,`%% %%>>>%%%>>%%>%%>>%>>%>%%%  %%>%%>%%>>%>%%%' % %,                       ||     ΚΩΔΙΚΑ Ή ΤΟ ΦΑΙ ΤΟΥ   ||
//      ,%>%'.>>%>%'%>>%%>%%%%>%'                 `%>%>>%%.`%>>%.                     ||                           ||
//    ,%%>' .>%>%'.%>%>>%%%>>%' ,%%>>%%>%>>%>>%>%%,.`%%%>%%. `%>%.                    ===============================
//   ` ,%' .>%%%'.%>%>>%' .,%%%%%%%%'          `%%%%%%.`%%>%% .%%>
//    .%>% .%%>' :%>>%%'.,%%%%%%%%%'.%%%%%' `%%%%.`%%%%%.%%%%> %%>%.
//   ,%>%' >>%%  >%' `%%%%'     `%%%%%%%'.,>,. `%%%%'     `%%%>>%%>%
//  .%%>%' .%%>'  %>>%, %% oO ~ Oo %%%>>'.>>>>>>. `% oO ~ Oo'.%%%'%>%,
//   %>'%> .%>%>%  %%>%%%'  `OoooO'.%%>>'.>>>%>>%>>.`%`OoooO'.%%>% '%>%
//   %',%' %>%>%'  %>%>%>% .%,>,>,   `>'.>>%>%%>>>%>.`%,>,>' %%%%> .>%>,
//   ` %>% `%>>%%. `%%% %' >%%%%%%>,  ' >>%>>%%%>%>>> >>%%' ,%%>%'.%%>>%.
//   .%%'  %%%%>%.   `>%%. %>%%>>>%.>> >>>%>%%%%>%>>.>>>'.>%>%>' %>>%>%%
//   `.%%  `%>>%%>    %%>%  %>>>%%%>>'.>%>>>>%%%>>%>>.>',%>>%'  ,>%'>% '
//    %>'  %%%%%%'    `%%'  %%%%%> >' >>>>%>>%%>>%>>%> %%>%>' .%>%% .%%
//   %>%>, %>%%>>%%,  %>%>% `%%  %>>  >>>%>>>%%>>>>%>>  %%>>,%>%%'.%>%,
//    %>%>%%, `%>%%>%>%, %>%%> ,%>%>>>.>>`.,.  `"   ..'>.%. % %>%>%'.%>%%;
//    %'`%%>%  %%>%%  %>% %'.>%>>%>%%>>%::.  `,   /' ,%>>>%>. >%>%'.%>%'%'
//    ` .%>%'  >%%% %>%%'.>%>%;''.,>>%%>%%::.  ..'.,%>>%>%>,`%  %'.>%%' '
//    %>%>%% `%>  >%%'.%%>%>>%>%>%>>>%>%>>%,,::,%>>%%>%>>%>%% `>>%>'
//     %'`%%>%>>%  %>'.%>>%>%>>;'' ..,,%>%>%%/::%>%%>>%%,,.``% .%>%%
// `    `%>%>>%%' %>%%>>%>>%>%>%>%%>%/'       `%>%%>%>>%%% ' .%'
//       %'  `%>% `%>%%;'' .,>>%>%/',;;;;;,;;;;,`%>%>%,`%'   '
//        `    `  ` `%>%%%>%%>%%;/ @a;;;;;;;;;;;a@  >%>%%'                  //////////////////////////////////////////////
//                   `/////////';, `@a@@a@@a@@aa@',;`//'                    // Περιγραφή: ΡΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑ-
//                       `//////.;;,,............,,;;//'                    // ΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑ
//                         `////;;;;;;;;;;;;;;;;;/'                         // ΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑ
//                            `/////////////////'                           // ΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑ
//                                                                          // ΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΑΡΡ
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import {
  AlertContext,
  ThemeContext,
  LangContext,
  MenuContext,
  Page,
  RegionContext,
  Theme,
  ThemeDark,
  ThemeLight,
  _Nav,
} from "monica-alexandria";
import React, { useState, useEffect, Profiler } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { GuardedRoute } from "../services/authentication/Guard";
import Navbar_ from "../components/navbar/Navbar_";
import { Protector } from "../services/authentication/Protector";
import TRANSLATIONS from "../admin/views/translations/TRANSLATIONS";
import PANEL from "../admin/views/panel/PANEL";
import PLANS from "../admin/views/plans/PLANS";
import SUBSCRIPTIONS from "../admin/views/subscriptions/SUBSCRIPTIONS";
import SUBSCRIBERS from "../admin/views/subscribers/SUBSCRIBERS";
import MY_PLANS from "../pages/myPlans/MY_PLANS";
import TEST_MQTT from "../pages/testMqtt/TEST_MQTT";
import TEST_PAYMENT from "../pages/testPayment/TEST_PAYMENT";
import ADD_PLAN from "../admin/views/addPlan/ADD_PLAN";
import NO_ACCESS from "../admin/views/noAccess/NO_ACCESS";
import { init, reconstructUrl } from "../helpers/initMenuOptions";
import { useSelector } from "react-redux";
import INVALID from "../pages/invalid/INVALID";
import SUBSCRIPTION from "../admin/views/subscription/SUBSRIPTION";
import i18n from "../localization/i18next";
import { CartContext } from "../context/CartContext";
import PAYMENT from "../pages/payment/PAYMENT";
import LOIS_CHECKOUT from "../pages/lois/LOIS_CHECKOUT.js";
import LOIS_SUBSCRIPTION from "../pages/lois/LOIS_SUBSCRIPTION.js";
import DAILYPROFIT_SUBSCRIPTION from "../pages/dailyprofit/DAILYPROFIT_SUBSCRIPTION.js";
import VANDADOR_SUBSCRIPTION from "../pages/vandador/VANDADOR_SUBSCRIPTION.js";
import VANDADOR_CHECKOUT from "../pages/vandador/VANDADOR_CHECKOUT.js";
import DAILYPROFIT_CHECKOUT from "../pages/dailyprofit/DAILYPROFIT_CHECKOUT.js";
import FIRST from "../pages/dummy/FIRST.js";
import SECOND from "../pages/dummy/SECOND.js";
import LOIS_SUBSCRIBE from "../pages/lois/LOIS_SUBSCRIBE.js";
import LOIS_CHECKOUT_V3 from "../pages/lois/LOIS_CHECKOUT_V3.js";
import LOIS_PLAN from "../pages/lois/LOIS_PLAN.js";
import SHIFT_SUBSCRIBE from "../pages/shift/SHIFT_SUBSCRIBE.js";
import SHIFT_CHECKOUT_V3 from "../pages/shift/SHIFT_CHECKOUT_V3.js";
import SHIFT_PLAN from "../pages/shift/SHIFT_PLAN.js";
import SHIFT_SUBSCRIPTION from "../pages/shift/SHIFT_SUBSCRIPTION.js";
import SHIFT_TOPUP from "../pages/shift/SHIFT_TOPUP.js";
import ARTIST_SUBSCRIBE from "../pages/shift/ARTIST_SUBSCRIBE.js";
import SIDEQUEST_CHECKOUT from "../pages/sidequest/SIDEQUEST_CHECKOUT.jsx";
import POCKET_AGENCY_PLAN from "../pages/pocketAgency/POCKET_AGENCY_PLAN.js";
import DAILYPROFIT_PLAN from "../pages/dailyprofit/DAILYPROFIT_PLAN.js";
import PLANS_V3 from "../admin/views/plansV3/PLANS_V3.js";
import CREATE_PLAN_V3 from "../admin/views/createPlan_V3/CREATE_PLAN_V3.js";
import ONE_PAGE_CHECKOUT from "../pages/dailyprofit/ONE_PAGE_CHECKOUT.js";
import SUBSCRIBER from "../admin/views/subscriber/SUBSCRIBER.js";
import DAILYPROFIT_SUBSCRIBER from "../admin/views/dailyprofitSubscriber/DAILYPROFIT_SUBSCRIBER.js";
import LOIS_SUBSCRIBER from "../admin/views/loisSubscriber/LOIS_SUBSCRIBER.js";
import POCKET_AGENCY_SUBSCRIBER from "../admin/views/pocketAgencySubscriber/POCKET_AGENCY_SUBSCRIBER.js";
import CUSTOM_POCKET_AGENCY from "../admin/views/customPocketAgency/CUSTOM_POCKET_AGENCY.js";
import STRIPE_POCKET_AGENCY from "../admin/views/stripePocketAgency/STRIPE_POCKET_AGENCY.js";
import { FiltersContext, FiltersProvider } from "../context/FiltersContext.js";
import DAILYPROFIT_INVOICES from "../admin/views/dailyprofitInvoices/DAILYPROFIT_INVOICES.js";
import STRIPE_SESSION from "../pages/stripeSession/STRIPE_SESSION.js";
import STATISTICS from "../admin/views/statistics/STATISTICS.js";
import DAILYPROFIT_STATISTICS from "../admin/views/dailyprofitStatistics/DAILYPROFIT_STATISTICS.js";
import LOIS_STATISTICS from "../admin/views/loisStatistics/LOIS_STATISTICS.js";
import BOND_STATISTICS from "../admin/views/bondStatistics/BOND_STATISTICS.js";
import SHIFT_STATISTICS from "../admin/views/shiftStatistics/SHIFT_STATISTICS.js";
import CRM_CHECKOUT from "../pages/crm/CRM_CHECKOUT";
import BOOST_CHECKOUT from "../pages/boost/BOOST_CHECKOUT.js";
import CRM_PLAN from "../pages/crm/crmPlan/CRM_PLAN.js";
import Product_Subscription from "../components/productSubscription/Product_Subscription.jsx";

export default function Microservice() {
  const authentication = process.env.REACT_APP_AUTHENTICATION;

  const user = useSelector((state) => state.user.user);

  const navigate = useNavigate();

  const [theme, setTheme] = useState();
  const [language, setLanguage] = useState();
  const [region, setRegion] = useState();
  const [activeMenu, setActiveMenu] = useState("Main");
  const [alerts, setAlerts] = useState([]);
  const [cart, setCart] = useState([]);
  // const [filters, setFilters] = useState({
  //     category: ['dailyprofit']
  // });

  const handleRender = (
    id,
    phase,
    actualDuration,
    baseDuration,
    startTime,
    commitTime,
    interactions
  ) => {};

  useEffect(() => {
    if (i18n?.language && reconstructUrl(language))
      navigate(reconstructUrl(language));
  }, [language]);

  useEffect(() => {
    init(user, setTheme, setLanguage, setRegion);
  }, [user]);

  return theme && language && region ? (
    <LangContext.Provider value={{ language, setLanguage }}>
      <RegionContext.Provider value={{ region, setRegion }}>
        <ThemeContext.Provider value={{ theme, setTheme }}>
          <ThemeProvider theme={theme === "dark" ? ThemeDark : ThemeLight}>
            <AlertContext.Provider value={{ alerts, setAlerts }}>
              <CartContext.Provider value={{ cart, setCart }}>
                {/* <FiltersContext.Provider value={{ filters, setFilters }} > */}
                <Theme>
                  <Page>
                    <MenuContext.Provider value={{ activeMenu, setActiveMenu }}>
                      {authentication == "ON" ? (
                        <GuardedRoute>
                          <Navbar_ />
                        </GuardedRoute>
                      ) : (
                        <Navbar_ />
                      )}
                    </MenuContext.Provider>

                    <Profiler id="all" onRender={handleRender}>
                      <Routes>
                        <Route
                          path="/:lang/test1"
                          element={
                              <FIRST />
                          }
                        />
                        <Route
                          path="/:lang/test2"
                          element={
                              <SECOND />
                          }
                        />
                        <Route
                          path="/:lang/adsnap-subscribe"
                          element={
                              <LOIS_SUBSCRIBE />
                          }
                        />
                        <Route
                          path="/:lang/adsnap-checkout-v3"
                          element={
                              <LOIS_CHECKOUT_V3 />
                          }
                        />
                        <Route
                          path="/:lang/shift-subscribe"
                          element={
                              <SHIFT_SUBSCRIBE />
                          }
                        />
                        <Route
                          path="/:lang/shift-checkout-v3"
                          element={
                              <SHIFT_CHECKOUT_V3 />
                          }
                        />
                        <Route
                          path="/"
                          element={
                            <Navigate
                              to={{
                                pathname: `/${language}/my-plans`,
                              }}
                            />
                          }
                        />
                        {/* UNPROTECTED */}
                        <Route
                          path="/:lang/checkout-details-av"
                          element={
                              <VANDADOR_CHECKOUT />
                          }
                        />
                        <Route
                          path="/:lang/payment"
                          element={
                              <PAYMENT />
                          }
                        />
                        {/* PROTECTED */}
                        <Route
                          path="/"
                          element={
                            <Protector>
                              <MY_PLANS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/"
                          element={
                            <Protector>
                              <MY_PLANS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/my-plans"
                          element={
                            <Protector>
                              <MY_PLANS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/subscription"
                          element={
                            <Protector role="Doer">
                              <VANDADOR_SUBSCRIPTION/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/subscription-questad"
                          element={
                            <Protector role="Doer">
                              <DAILYPROFIT_SUBSCRIPTION/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/checkout-details-questad"
                          element={
                            <Protector role="Doer">
                              <DAILYPROFIT_CHECKOUT />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/questad-checkout"
                          element={
                            <Protector role="Doer">
                              <ONE_PAGE_CHECKOUT />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/crm-checkout"
                          element={
                            <Protector role="Doer">
                              <CRM_CHECKOUT />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/boost-checkout"
                          element={
                            <Protector role="Doer">
                              <BOOST_CHECKOUT />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/checkout-details-adsnap"
                          element={
                            <Protector role="Doer">
                              <LOIS_SUBSCRIBE />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/checkout-details-shift"
                          element={
                            <Protector role="Doer">
                              <SHIFT_SUBSCRIBE />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/subscription-adsnap"
                          element={
                            <Protector role="Doer">
                              <LOIS_SUBSCRIPTION/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/adsnap"
                          element={
                            <Protector role="Doer">
                              <LOIS_PLAN/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/subscription-shift"
                          element={
                            <Protector role="Doer">
                              <SHIFT_SUBSCRIPTION/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/shift"
                          element={
                            <Protector role="Doer">
                              <SHIFT_PLAN/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/artist"
                          element={
                            <Protector role="Doer">
                              <Product_Subscription category="artist" name="Artist" />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/sidequest"
                          element={
                            <Protector role="Doer">
                              <Product_Subscription category="sidequest" name="Sidequest" />
                            </Protector>
                          }
                        />
                        <Route path="/:lang/artist-subscribe" element={<Protector role="Doer"><ARTIST_SUBSCRIBE /></Protector>} />
                        <Route path="/:lang/sidequest-checkout" element={<Protector role="Doer"><SIDEQUEST_CHECKOUT /></Protector>} />
                        <Route
                          path="/:lang/shift-topup"
                          element={
                            <Protector role="Doer">
                              <SHIFT_TOPUP/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/pocket-agency"
                          element={
                            <Protector role="Doer">
                              <POCKET_AGENCY_PLAN/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/questad"
                          element={
                            <Protector role="Doer">
                              <DAILYPROFIT_PLAN/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/plan/crm"
                          element={
                            <Protector role="Doer">
                              <CRM_PLAN />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/stripe-session"
                          element={
                            <Protector role="Doer">
                              <STRIPE_SESSION/>
                            </Protector>
                          }
                        />
                        {/* ADMIN */}
                        <Route
                          path="/:lang/akihiko/griphook"
                          element={
                            <Protector role="Merchant">
                              <PANEL />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/translations"
                          element={
                            <Protector role="Knight">
                              <TRANSLATIONS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/plans"
                          element={
                            <Protector role="Merchant">
                              <PLANS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/plans-v3"
                          element={
                            <Protector role="Merchant">
                              <PLANS_V3/>
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/add-plan"
                          element={
                            <Protector role="Baron">
                              <ADD_PLAN />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/create-plan"
                          element={
                            <Protector role="Merchant">
                              <CREATE_PLAN_V3 />
                            </Protector>
                          }
                        />
                          <Route
                          path="/:lang/akihiko/griphook/statistics"
                          element={
                            <Protector role="Merchant">
                              <STATISTICS />
                            </Protector>
                          }
                        />
                        
                        <Route
                          path="/:lang/akihiko/griphook/statistics/questad"
                          element={
                            <Protector role="Merchant">
                              <DAILYPROFIT_STATISTICS />
                            </Protector>
                          }
                        />
                         <Route
                          path="/:lang/akihiko/griphook/statistics/adsnap"
                          element={
                            <Protector role="Merchant">
                              <LOIS_STATISTICS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/statistics/pocket-agency"
                          element={
                            <Protector role="Merchant">
                              <BOND_STATISTICS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/statistics/shift"
                          element={
                            <Protector role="Merchant">
                              <SHIFT_STATISTICS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/statistics/all-products"
                          element={
                            <Protector role="Merchant">
                              <SHIFT_STATISTICS
                                title="All products"
                                products={['dailyprofit', 'lois', 'bond', 'shift']}
                              />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscriptions"
                          element={
                            <Protector role="Baron">
                              <SUBSCRIPTIONS />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscribers"
                          element={
                            <Protector role="Baron">
                              <SUBSCRIBERS />
                            </Protector>
                          }
                        />
                        
                        <Route
                          path="/:lang/akihiko/griphook/subscribers/:id"
                          element={
                            <Protector role="Baron">
                              <SUBSCRIBER />
                            </Protector>
                          }
                        />
                         <Route
                          path="/:lang/akihiko/griphook/subscribers/questad/:id"
                          element={
                            <Protector role="Baron">
                              <DAILYPROFIT_SUBSCRIBER />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscribers/adsnap/:id"
                          element={
                            <Protector role="Baron">
                              <LOIS_SUBSCRIBER />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscribers/pocket-agency/:id/"
                          element={
                            <Protector role="Baron">
                              <POCKET_AGENCY_SUBSCRIBER />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscribers/pocket-agency/custom/:id/"
                          element={
                            <Protector role="Baron">
                              <CUSTOM_POCKET_AGENCY />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscribers/pocket-agency/stripe/:id/:cusId"
                          element={
                            <Protector role="Baron">
                              <STRIPE_POCKET_AGENCY />
                            </Protector>
                          }
                        />
                         <Route
                          path="/:lang/akihiko/griphook/subscribers/questad/:id/:questId"
                          element={
                            <Protector role="Baron">
                              <DAILYPROFIT_INVOICES />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/akihiko/griphook/subscription"
                          element={
                            <Protector role="Baron">
                              <SUBSCRIPTION />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/invalid"
                          element={
                            <GuardedRoute>
                              <INVALID />
                            </GuardedRoute>
                          }
                        />
                        {/* TESTING */}
                        <Route
                          path="/:lang/test-mqtt"
                          element={
                            <Protector>
                              <TEST_MQTT />
                            </Protector>
                          }
                        />
                        <Route
                          path="/:lang/test-payment"
                          element={<TEST_PAYMENT />}
                        />
                        {/* MISC */}
                        <Route
                          path="/:lang/access-denied"
                          element={<NO_ACCESS />}
                        />
                      </Routes>
                    </Profiler>
                  </Page>
                </Theme>
                {/* </FiltersContext.Provider> */}
              </CartContext.Provider>
            </AlertContext.Provider>
          </ThemeProvider>
        </ThemeContext.Provider>
      </RegionContext.Provider>
    </LangContext.Provider>
  ) : (
    <></>
  );
}
